function closeNagAlert(e) {
  const $closeBtn = $(this);
  const $nagAlert = $closeBtn.parents('[data-nag-alert]');

  e.preventDefault();
  $.post($nagAlert.data('close-alert-path'));
  $nagAlert.hide();
}

function init() {
  $(document).on('click', '[data-close-nag-alert]', closeNagAlert);
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/nag_alerts.js